'use client';
import { useField } from 'formik';

import { classNames } from '@repo/ui/src/utils/classNames';
import { InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name: string;
  className?: string;
  inputStyles?: string;
  hideLabel?: boolean;
  labelStyles?: string;
  darkBackground?: boolean;
}

const Input = ({
  label,
  className,
  inputStyles,
  hideLabel,
  labelStyles,
  required = false,
  darkBackground = false,
  ...props
}: InputProps) => {
  const [field, meta] = useField(props);
  const showError = meta.touched && meta.error;

  return (
    <div className={classNames('tw-w-full', className)}>
      <label
        className={classNames('tw-w-full tw-flex tw-flex-col tra-text-web-body-m', labelStyles)}
      >
        {!hideLabel && (
          <span className="tw-mb-2 dark:tw-text-warm-100">
            {label}
            {required && ' *'}
          </span>
        )}
        <input
          aria-describedby={showError ? `${props.name}-error` : undefined}
          className={classNames(
            'tra-input-text',
            'tra-text-web-body-m',
            meta.touched && meta.error && 'tw-border-red-400',
            inputStyles,
          )}
          aria-required={required ?? 'true'}
          {...field}
          {...props}
        />
      </label>
      {showError ? (
        <span 
          className={classNames(
            'tra-input-error',
            darkBackground && 'tw-text-alert-200'
          )} 
          id={`${props.name}-error`} 
          data-testid="input-error"
        >
          {meta.error}
        </span>
      ) : null}
    </div>
  );
};

export default Input;
